<planning-top-nav></planning-top-nav>

<div class="work-orders-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Header -->
  <div class="header" *ngIf="!isLoading">
    <h2>Work Orders</h2>

    <div class="header-actions">
      <button
        type="button"
        class="btn btn-primary"
        (click)="goToAssign()"
      >
        Assign Work Orders
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="openCreateModal()"
      >
        + New Work Order
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="goToImport()"
      >
        Import Work Orders
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-container" *ngIf="!isLoading">
    <div class="filters-row">
      <label class="filter-field search-field">
        <span>Search</span>

        <input
          type="text"
          [(ngModel)]="filters.searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
          placeholder="Search WON or description"
        />
      </label>

      <label class="filter-field">
        <span>Department</span>

        <select
          [(ngModel)]="selectedDepartmentId"
          (ngModelChange)="onDepartmentChange($event)"
        >
          <option [ngValue]="null">
            All departments
          </option>

          <option
            *ngFor="let dept of filterService.filterValues?.departments"
            [ngValue]="dept.id"
          >
            {{ dept.code }} - {{ dept.name }}
          </option>
        </select>
      </label>

      <label class="filter-field">
        <span>Project</span>

        <select
          [(ngModel)]="filters.projectId"
          (ngModelChange)="onProjectChange($event)"
        >
          <option [ngValue]="null">
            All projects
          </option>

          <option
            *ngFor="let project of filterService.filterValues?.projects"
            [ngValue]="project.id"
          >
            {{ project.name }}
          </option>
        </select>
      </label>

      <label class="filter-field">
        <span>Type</span>

        <select
          [ngModel]="
            filters.isOverhead === null
              ? 'all'
              : filters.isOverhead
                ? 'true'
                : 'false'
          "
          (ngModelChange)="onIsOverheadChange($event)"
        >
          <option value="all">
            All work orders
          </option>

          <option value="true">
            Overhead only
          </option>

          <option value="false">
            Non-overhead only
          </option>
        </select>
      </label>

      <div class="filter-actions">
        <button
          type="button"
          class="clear-filters-btn"
          (click)="clearFilters()"
          [disabled]="!hasActiveFilters"
        >
          Clear Filters
        </button>
      </div>
    </div>
  </div>

  <!-- Sticky Pagination -->
  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button
        type="button"
        (click)="changePage(currentPage - 1)"
        [disabled]="currentPage === 1"
      >
        Prev
      </button>

      <span>
        Page {{ currentPage }} of {{ totalPages }}
      </span>

      <button
        type="button"
        (click)="changePage(currentPage + 1)"
        [disabled]="currentPage === totalPages"
      >
        Next
      </button>
    </div>

    <div class="page-size">
      <label for="pageSize">
        Page Size:
      </label>

      <select
        id="pageSize"
        [(ngModel)]="pageSize"
        (ngModelChange)="changePageSize($event)"
      >
        <option
          *ngFor="let size of pageSizes"
          [ngValue]="size"
        >
          {{ size }}
        </option>
      </select>
    </div>
  </div>

  <!-- Work Orders List -->
  <div class="work-orders-list">
    <div
      *ngFor="let wo of workOrders$ | async"
      class="work-order-row"
    >
      <div class="work-order-info">
        <div class="work-order-won">
          {{ wo.won }}
        </div>

        <div class="work-order-meta">
          <span class="department">
            Dept: {{ wo.department.code }}
          </span>

          <span class="project" *ngIf="wo.project">
            Project: {{ wo.project.name }}
          </span>

          <span class="work-order-type">
            {{ wo.isOverhead ? 'Overhead' : 'Non-overhead' }}
          </span>

          <span class="work-order-status">
            {{ wo.isActive ? 'Active' : 'Inactive' }}
          </span>
        </div>

        <div class="work-order-description">
          {{ wo.description || '' }}
        </div>
      </div>

      <div class="work-order-actions">
        <button
          type="button"
          class="btn edit"
          (click)="openEditModal(wo)"
        >
          Edit
        </button>
      </div>
    </div>
  </div>

  <!-- Create / Edit Modal -->
  <div
    *ngIf="modalOpen"
    class="modal-backdrop"
    (click)="closeModal()"
  >
    <div
      class="modal"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="
        isEditMode ? 'Edit Work Order' : 'New Work Order'
      "
      (click)="$event.stopPropagation()"
    >
      <h2>
        {{ isEditMode ? 'Edit Work Order' : 'New Work Order' }}
      </h2>

      <form
        #workOrderForm="ngForm"
        (ngSubmit)="submitWorkOrder(workOrderForm)"
        novalidate
      >
        <!-- WON -->
        <label for="won">
          Work Order Number
        </label>

        <input
          id="won"
          type="text"
          name="won"
          [(ngModel)]="formModel.won"
          required
          [disabled]="isEditMode"
        />

        <!-- Department -->
        <label for="departmentCode">
          Department
        </label>

        <select
          id="departmentCode"
          name="departmentCode"
          [(ngModel)]="formModel.departmentCode"
          required
          [disabled]="isEditMode"
        >
          <option value="" disabled>
            Select Department
          </option>

          <option
            *ngFor="let dept of filterService.filterValues?.departments"
            [value]="dept.code"
          >
            {{ dept.code }} - {{ dept.name }}
          </option>
        </select>

        <!-- Project -->
        <label for="project">
          Project
        </label>

        <select
          id="project"
          name="project"
          [(ngModel)]="formModel.project"
          required
          [disabled]="isEditMode"
        >
          <option [ngValue]="null" disabled>
            Select Project
          </option>

          <option
            *ngFor="let proj of filterService.filterValues?.projects"
            [ngValue]="proj.name"
          >
            {{ proj.name }}
          </option>
        </select>

        <!-- Description -->
        <label for="description">
          Description
        </label>

        <textarea
          id="description"
          name="description"
          [(ngModel)]="formModel.description"
          rows="4"
        ></textarea>

        <!-- Overhead -->
        <label class="checkbox-field" for="isOverhead">
          <input
            id="isOverhead"
            type="checkbox"
            name="isOverhead"
            [(ngModel)]="formModel.isOverhead"
          />

          <span>
            Overhead Work Order
          </span>
        </label>

        <!-- Status -->
        <label for="isActive">
          Status
        </label>

        <select
          id="isActive"
          name="isActive"
          [(ngModel)]="formModel.isActive"
        >
          <option value="true">
            Active
          </option>

          <option value="false">
            Inactive
          </option>
        </select>

        <!-- Buttons -->
        <div class="modal-buttons">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeModal()"
          >
            Cancel
          </button>

          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="workOrderForm.invalid"
          >
            {{ isEditMode ? 'Update' : 'Create' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Toast -->
  <div
    *ngIf="toastVisible"
    class="toast"
    [ngClass]="toastType"
    role="status"
    aria-live="polite"
  >
    <img class="icon" alt="" />
    <span>{{ toastMessage }}</span>
  </div>
</div>